import { ComponentPropsWithoutRef } from 'react';

export function Tr(props: ComponentPropsWithoutRef<'tr'>) {
  return <tr {...props} className="border-b-grayscale100 border-b" />;
}
